import Panel from '../../../object-view/objects/panel';
import { VERTICES as types } from '../types';


export default [
  {
    id: 'square',
    icon: 'icon_editor-shape-square',
    config: {
      panel: {
        type: Panel.types.CUSTOM,
        vertices: {
          count: 4
        }
      },
      custom: {
        type: types.SQUARE
      }
    },
    tooltip:"TT224"
  },
  {
    id: 'triangle',
    icon: 'icon_editor-shape-triangle',
    config: {
      panel: {
        type: Panel.types.CUSTOM,
        vertices: {
          count: 3
        }
      },
      custom: {
        type: types.TRIANGLE
      }
    },
    tooltip:"TT225"
  },
  {
    id: 'circle',
    icon: 'icon_editor-shape-circle',
    config: {
      panel: {
        type: Panel.types.CUSTOM,
        vertices: {
          count: 1
        }
      },
      custom: {
        type: types.CIRCLE
      }
    },
    tooltip:"TT226"
    
  },
  {
    id: 'hexagon',
    icon: 'icon_editor-shape-hexagon',
    config: {
      panel: {
        type: Panel.types.CUSTOM,
        vertices: {
          count: 6
        }
      },
      custom: {
        type: types.HEXAGON
      }
    },
    tooltip:"TT227"
  },
  {
    id: 'octagon',
    icon: 'icon_editor-shape-octagon',
    config: {
      panel: {
        type: Panel.types.CUSTOM,
        vertices: {
          count: 8
        }
      },
      custom: {
        type: types.OCTAGON
      }
    },
    tooltip:"TT228"
  }
];



// WEBPACK FOOTER //
// ./src/components/Editor/Plate/buttons.js